import { FleetBase } from '../../../domain/fleet';
import { OtherIndividualInfo, PersonalInfo, PreliminaryInfo } from '../../../domain/person';
import { PortalType } from '../../../domain/portal';
import { Person, QualifyingUserAndCompany } from '../../../domain/qualification';
import { RootState } from '../../index';

function mapCompanyAndPersonInfo({
  preliminaryInfo,
  personalInfo,
  fleet,
  otherIndividuals,
  personaInquiryId,
  portalType,
}: {
  preliminaryInfo: PreliminaryInfo;
  personalInfo: PersonalInfo;
  fleet: FleetBase;
  otherIndividuals: OtherIndividualInfo[];
  portalType: PortalType;
  personaInquiryId?: string;
}): QualifyingUserAndCompany {
  const { phone, email } = preliminaryInfo;
  const { address: fleetAddress, shippingAddress, ...fleetInfo } = fleet;
  const applicant: Person = { ...personalInfo, phone, isApplicant: true, personaInquiryId };

  return {
    people: [
      ...(portalType === 'apply' ? [applicant] : []),
      ...otherIndividuals.map((individual) => {
        const { uiId: _uiId, ...individualWithoutUiId } = individual;
        return {
          ...individualWithoutUiId,
          isApplicant: false,
          authorizedRep: false,
        };
      }),
    ],
    fleet: {
      companyEmail: email,
      shippingStreetAddress: shippingAddress?.streetAddress,
      shippingStreetAddress2: shippingAddress?.streetAddress2,
      shippingCity: shippingAddress?.city,
      shippingState: shippingAddress?.state,
      shippingZip: shippingAddress?.zip,
      ...fleetInfo,
      ...fleetAddress,
    },
  };
}

function qualificationSelector(state: RootState): QualifyingUserAndCompany {
  const {
    preliminaryInfo: { info: preliminaryInfo },
    personalInfo: { info: personalInfo },
    businessInfo: { info: fleet },
    otherIndividuals: { individuals: otherIndividuals },
    portal: { portalType },
    persona,
  } = state;
  return mapCompanyAndPersonInfo({
    preliminaryInfo,
    personalInfo,
    fleet,
    otherIndividuals,
    personaInquiryId: persona.inquiryId,
    portalType,
  });
}

export { qualificationSelector };
